import svgSrc from '@assets/undraw/undraw_mailbox_re_dvds.svg'
import { AnimatedContentLoader, CopyValue, ImageMessageBox } from '@components'
import { useBusinessContext } from '@context'
import { fetchBusiness } from '@query'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import styled from 'styled-components'
import { EInvoicingShareCard } from './EInvoicingShareCard'

export const EInvoicingDetails: React.FC = () => {
  const { t } = useTranslation()
  const { slug } = useBusinessContext()

  const { data, isLoading } = useQuery({
    queryKey: [slug],
    queryFn: () => fetchBusiness({ slug })
  })

  const canShare = Boolean(
    data?.einvoicing_enabled && data.einvoicing_address && data.einvoicing_operator
  )

  return (
    <AnimatedContentLoader isLoading={isLoading}>
      <Stack>
        <ImageMessageBox imgSrc={svgSrc}>
          <EinvoiceAddressContainer>
            <EinvoiceAddressContent>
              <p>{t('settings.einvoicing.detailsDescription')}</p>

              <h4>{t('settings.einvoicing.einvoicingAddress')}:</h4>
              <CopyValue value={data?.einvoicing_address} />

              <br />
              <h4>{t('settings.einvoicing.einvoicingOperator')}:</h4>
              <CopyValue value={data?.einvoicing_operator} />
              <OperatorNote>
                <Trans
                  i18nKey="settings.einvoicing.operatorInfo"
                  values={{ name: data?.einvoicing_operator_name || 'Apix' }}
                >
                  <OperatorLink href="https://apix.fi/" target="_blank" rel="noreferrer" />
                </Trans>
              </OperatorNote>
            </EinvoiceAddressContent>
          </EinvoiceAddressContainer>
        </ImageMessageBox>
        {canShare && data && <EInvoicingShareCard business={data} />}
      </Stack>
    </AnimatedContentLoader>
  )
}

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

const EinvoiceAddressContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xl}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  color: ${({ theme }) => theme.colors.neutralBlack};
  margin: ${({ theme }) => theme.spacing.md}rem 0;
`

const EinvoiceAddressContent = styled.div`
  flex: 1;
`

const OperatorNote = styled.p`
  margin: ${({ theme }) => theme.spacing.xs}rem 0 0;
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
`

const OperatorLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
